export default __webpack_public_path__ + "static/media/closeVideo.13f1a308.svg";